<template>
  <div class="creditService">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="creditServiceMain">
      <div class="creditServiceCon">
        <h4 class="hidden-xs">信用控制风险，为采购企业获得更多优质供应商</h4>
        <h4>供应商秀出自己的诚信和实力，信用换取更多商机</h4>
        <p>
          <span>为构建阳光诚信交易环境，促成买家卖家高效达成交易，一链网特别推出征信增值服务。</span>
          <span>本服务通过对接权威第三方征信机构旨为企业经营现状及综合实力提供评估证明</span>
        </p>
      </div>
      <div class="creditServiceList">
        <ul class="creditServiceScroll clearfix">
          <li class="col-lg-6 col-md-6 col-sm-5 col-xs-5">
            <h4><span class="titLine"></span>征信报告</h4>
            <p>凭借丰富的数据资源以及大数据处理能力，由权威征信机构从企业背景、企业规模、公共记录、财务状况（增强版）平台数据及行业展望等维度全方位评估企业信用风险并生成征信报告。</p>
            <button type="button" class="btn btn-default btn-lg" @click="centerDialogVisible = true">立即体验</button>
          </li>
          <li class="col-lg-6 col-md-6 col-sm-5 col-xs-5">
            <h4><span class="titLine"></span>独立性验证报告</h4>
            <p>通过多维全量信息查询，运用海量数据和大数据交叉分析技术，深度追踪选定范围内企业与企业、企业与人、人与人之间的关系路径，从而判定企业与企业之间控股或从属关系，直接或间接股关系。为采购方提供风险决策依据，有效管控供应商准入，降低招投标围标、串标风险。</p>
            <button type="button" class="btn btn-default btn-lg" @click="centerDialogVisible = true">立即体验</button>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      title=""
      custom-class="experienceDialog"
      :visible.sync="centerDialogVisible"
      :lock-scroll="false"
      width="30%"
      center>
      <p class="hotline">如需更好的了解一链采购供应链数智化系统，寻求更多采购供应链解决方案，入驻成为平台采购商，请您填写以下信息，或拨打免费服务热线：<span>400-108-6116</span></p>
      <el-form :model="ruleForm" :rules="rules" ref="recruitForm" label-width="92px" class="demo-ruleForm">
        <!--<el-form-item label="角色" prop="roleName">-->
          <!--<el-select v-model="ruleForm.roleName" placeholder="请输入角色">-->
            <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
<!--        <el-form-item label="角色" prop="roleName">-->
<!--          <el-radio-group v-model="ruleForm.roleName">-->
<!--            <el-radio v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入姓名"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionName">
          <el-input v-model="ruleForm.positionName" placeholder="请输入职位"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contractPhone">
          <el-input v-model="ruleForm.contractPhone" placeholder="请输入联系电话"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称" :maxlength="50"></el-input>
        </el-form-item>
<!--        <el-form-item label="试用平台" prop="trialPlatform">-->
<!--          <el-checkbox-group v-model="ruleForm.trialPlatform" @change="handleChange">-->
<!--            <el-checkbox label="采招平台" ></el-checkbox>-->
<!--            <el-checkbox label="协同平台" ></el-checkbox>-->
<!--            <el-checkbox label="供应商管理" ></el-checkbox>-->
<!--            <el-checkbox label="征信产品" ></el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->
        <div class="clearfix">
          <div class="trialPlatform-label pull-left">
            <i style="color: #f56c6c;">*</i>
            我的需求
            <el-tooltip class="item" effect="dark" content="贵公司希望通过一链网，解决当前采购遇到的哪些问题？" placement="top">
              <el-button type="text" style="vertical-align: middle;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </div>
          <div class="pull-left trialPlatform-item" style="width: 300px;font-size: 12px">
            <el-form-item label-width="0" prop="trialPlatform">
              <el-input v-model="ruleForm.trialPlatform"
                        style="font-size: 12px;"
                        type="textarea"
                        :maxlength="100"
                        :show-word-limit="true"
                        placeholder="如 电子招标、供应商管理、合同管理"
                        :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        footerColumnInfos: [],
        navigationColumnInfos: [],
        bannerInfo: {title: '将企业数据转换成信用资产', content: '为您提供值得买家青睐的全景画像'},
        webConfigInfo: {},
        messageData: [],
        messageTotal:0,
        currentPage:1,
        centerDialogVisible:false,
        ruleForm: {
          // roleName: '',
          userName: '',
          positionName: '',
          contractPhone: '',
          companyName: '',
          trialPlatform: ''
        },
        checkList:[],
        rules: {
          // roleName: [
          //   { required: true, message: '请选择角色', trigger: 'change' }
          // ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }
          ],
          trialPlatform: [
            { required: true, message: '请输入您的需求', trigger: 'blur' }
          ]
        },
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{}
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
      this.ulWidth();
      this.resizeUlWidth();
    },
    methods: {
      ulWidth () {
          // 动态计算ul的宽度
          let scrollwrap = $('.creditServiceScroll')
          let lis = $('li', scrollwrap)
          let sum = 0
          // 遍历每一个li元素
          lis.each(function (index, el) {
            let _el = $(el)
            // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
            // outerWidth 代表的是border+padding+width
            sum += _el.outerWidth(true)
          })
          // 将累加的值直接复制给ul元素
          scrollwrap.width(sum)
      },
      resizeUlWidth(){
        $(window).resize(() => {
          if($('.creditServiceList').width() < 750){
            this.ulWidth();
          }else{
            $('.creditServiceScroll').width('auto')
          }
        })
      },
      submitForm() {
        this.$refs['recruitForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addTaskInfo', {
              taskSource: 0,
              // roleName: this.ruleForm.roleName,
              userName: this.ruleForm.userName,
              positionName:this.ruleForm.positionName,
              contractPhone: this.ruleForm.contractPhone,
              companyName: this.ruleForm.companyName,
              trialPlatform: this.ruleForm.trialPlatform,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
              let operateNumber = this.data.data;
              if(res.data.code == '0'){
                if(this.getToken('isLogin') == ''){

                  if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                    });
                    return;
                  } else {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                    });
                    return;
                  }



                }else{
                  this.$message({
                     message: "试用申请已提交",
                     type: 'success'
                 });
                }
                 this.centerDialogVisible = false;
              }else{
                this.$message({
                     message: "试用提交失败!",
                     type: 'error'
                 });
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            return false;
          }
        });
      },
      // handleChange(value){
      //   this.ruleForm.trialPlatform = value;
      // },
      jump(){
        this.$router.push({path:"/register"})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/creditService/index.vue